export default __webpack_public_path__ + "static/grow3-6ee98ac91dc646365fc987aade60860d.png";